function modulesPricingDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/modules-pricing/modules-pricing-dialog.html?$$REVISION$$'
  }
}
export { modulesPricingDialog }
